// extracted by mini-css-extract-plugin
var _1 = "BestValueCard_badge__KGxAa";
var _2 = "BestValueCard_badgeCenter__hNrOi";
var _3 = "BestValueCard_badgeLeft__s2WnI";
var _4 = "BestValueCard_badgeRight__BOF44";
var _5 = "BestValueCard_billingData__PrtGr";
var _6 = "BestValueCard_billingInformation__7sT6x";
var _7 = "BestValueCard_priceWrapper__gyw-j";
var _8 = "BestValueCard_wrapper__O1gF-";
var _9 = "BestValueCard_wrapperBadge__m3bVG";
var _a = "BestValueCard_wrapperCenter__iWKdf";
var _b = "BestValueCard_wrapperLarge__hYtxv";
var _c = "BestValueCard_wrapperLeft__SXGxn";
var _d = "BestValueCard_wrapperList__JsX0g";
export { _1 as "badge", _2 as "badgeCenter", _3 as "badgeLeft", _4 as "badgeRight", _5 as "billingData", _6 as "billingInformation", _7 as "priceWrapper", _8 as "wrapper", _9 as "wrapperBadge", _a as "wrapperCenter", _b as "wrapperLarge", _c as "wrapperLeft", _d as "wrapperList" }
